module.exports = __webpack_public_path__ + "static/fonts/trebuchet_ms.6720399.woff2";